var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.PRODUCTS.length
    ? _c(
        "div",
        { staticClass: "product-gallery-recently-viewed" },
        [
          _c("product-gallery", {
            attrs: { title: "Просмотренные товары", products: _vm.PRODUCTS }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }